/**
 * This is the establishMemword data service.
 * @memberOf establishMemword Module
 * @namespace establishMemword Data Service
 */

/**
 * @name establishMemwordDataService
 * @desc Create the data service.
 * @param $q
 * @param $http
 * @param coreService
 * @memberOf establishMemword Module.establishMemword Data Service
 * @ngInject
 */
var establishMemwordDataFactory = function ($q, $http, coreService) {
    // Create the service.
    var service = { };
    return service;
    
}

export default establishMemwordDataFactory;



// WEBPACK FOOTER //
// ./src/login/establishmemword/establishmemword.data.service.js